import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../utils/constants';

interface RequireMembershipProps {
  children: React.ReactNode;
  redirectTo?: string;
  schoolId?: string;
}

export const RequireMembership: React.FC<RequireMembershipProps> = ({
  children,
  redirectTo = ROUTES.LOGIN,
  schoolId,
}) => {
  const { user } = useAuth();

  const hasMembership = user?.memberships?.some((membership) => {
    if (schoolId) {
      return membership.school_id === schoolId;
    }
    return !!membership.school_id;
  });

  if (!hasMembership) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

